<template>
  <ux-form
    class="x-padding-x"
    ref="form"
    :data="formData"
    :rules="rules"
    label-width="auto"
    data-automation="bindEmail"
  >
    <ux-form-item :label="$t('HT.addUser.email')" labelWidth="auto" required prop="email">
      <ux-input v-model="formData.email" size="small" :placeholder="$t('HT.rules.bindemail.email')"></ux-input>
    </ux-form-item>
  </ux-form>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          email: ''
        };
      }
    }
  },

  data() {
    return {
      formData: JSON.parse(JSON.stringify(this.data)),
      rules: this.$rul.bindemail(this)
    };
  }
};
</script>
